import { render, staticRenderFns } from "./CitiesView.vue?vue&type=template&id=4325a700&scoped=true"
import script from "./CitiesView.vue?vue&type=script&lang=js"
export * from "./CitiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4325a700",
  null
  
)

export default component.exports